export type VideoKind = "short" | "long";

export interface SiteVideo {
  youtubeId: string;
  title: string;
  kind: VideoKind;
}

// Every video on the site plays from YouTube so plays count as channel views.
// Keys double as blog slugs.
export const VIDEOS = {
  "hypestream-intro": {
    youtubeId: "KO_g64C06xg",
    title: "Copy top Whatnot seller techniques with HypeStream",
    kind: "long",
  },
  "customer-support-10x": {
    youtubeId: "IAIxacm8sdE",
    title: "We made Whatnot seller support 10x better",
    kind: "long",
  },
  "record-whatnot-shows-hd": {
    youtubeId: "RpwPm6oLDmA",
    title: "How to record your Whatnot shows in HD (and clip the best moments)",
    kind: "long",
  },
  "half-the-viewers-double-per-viewer": {
    youtubeId: "Z1-BXSWT5bI",
    title: "He had half the viewers but double the $$ per viewer",
    kind: "short",
  },
  "one-dollar-starts-12500": {
    youtubeId: "cvTb-ldRMVs",
    title: "He started prices at $1 then made $12,500",
    kind: "short",
  },
  "gave-away-1k-made-100k": {
    youtubeId: "ZKWJOw2LfBo",
    title: "He gave away $1k, then made back $100k",
    kind: "short",
  },
  "same-thing-4k-more-per-hour": {
    youtubeId: "8nStbFDISf0",
    title: "He sells $4k/h more selling the same thing",
    kind: "short",
  },
  "plants-1100-in-an-hour": {
    youtubeId: "tInAr7riujI",
    title: "He sold $1.1k in an hour selling plants",
    kind: "short",
  },
  "three-tricks-10x-same-day": {
    youtubeId: "Aj0iHjttmb4",
    title: "He used 3 tricks to earn 10x more in the same day",
    kind: "short",
  },
  "500k-inventory-mistake": {
    youtubeId: "lgfF6pbHLgo",
    title: "The $500K inventory mistake Whatnot sellers make",
    kind: "short",
  },
  "chatgpt-zero-mentions": {
    youtubeId: "029Y4Klu_M4",
    title: "Whatnot: 300K+ followers. ChatGPT: 0 mentions.",
    kind: "short",
  },
  "charges-20-more-sells-more": {
    youtubeId: "JU2NbW5f-Dc",
    title: "He charges $20 more but more people buy from him",
    kind: "short",
  },
  "boring-seller-1-million-items": {
    youtubeId: "Bf4UPI2Y1c4",
    title: "This boring liveseller sold over 1 million items",
    kind: "short",
  },
  "more-viewers-less-sales": {
    youtubeId: "_igXIpF01BY",
    title: "When more viewers means less sales",
    kind: "short",
  },
  "high-margin-less-money": {
    youtubeId: "0QqQVN16ciU",
    title: "Your high-margin Whatnot business is making you less money",
    kind: "short",
  },
  "best-buy-it-now-price": {
    youtubeId: "0UTMnttvyM0",
    title: "Find the best price for your Whatnot Buy It Nows",
    kind: "short",
  },
  "ecommerce-trick-losing-money": {
    youtubeId: "zx2w77uTK08",
    title: "You're losing money on Whatnot if you don't know this ecommerce trick",
    kind: "short",
  },
  "100k-vs-1k-seller-showdown": {
    youtubeId: "l0oKZuG-cGM",
    title: "100k vs 1k follower Whatnot seller showdown",
    kind: "short",
  },
  "streams-look-like-this": {
    youtubeId: "LmZyQ1JH-ko",
    title: "You're losing money on Whatnot if your streams look like this",
    kind: "short",
  },
  "stop-advertising-for-free": {
    youtubeId: "S73KZoVWW6Y",
    title: "Whatnot sellers: stop advertising for free",
    kind: "short",
  },
  "earn-thousands-per-hour": {
    youtubeId: "k8LdpN3b7c8",
    title: "Earn thousands per hour on Whatnot using these tricks",
    kind: "short",
  },
} as const satisfies Record<string, SiteVideo>;

export type VideoKey = keyof typeof VIDEOS;

export function isVideoKey(key: string): key is VideoKey {
  return key in VIDEOS;
}

// 1280x720, double hqdefault's 480x360. Shorts too: YouTube only renders a
// Short's custom thumbnail into these landscape sizes (centred, ~405px wide);
// the vertical oardefault/oar2 files are auto-picked frames, not the custom one.
export function youtubeThumbnailUrl(key: VideoKey): string {
  return `https://i.ytimg.com/vi/${VIDEOS[key].youtubeId}/maxresdefault.jpg`;
}

export function youtubeWatchUrl(key: VideoKey): string {
  return `https://www.youtube.com/watch?v=${VIDEOS[key].youtubeId}`;
}
